export default __webpack_public_path__ + "static/media/signature-steven-rosato-secondary.b4ac6a40.svg";